module.exports = __webpack_public_path__ + "img/panelView_strong_2_2.325a1f4a.png";